module.exports = __webpack_public_path__ + "img/kep10.30b8d9d1.jpg";